import {createActions} from 'client/framework';

export default createActions(null, ['TOGGLE_IS_TOP_DRAWER_OPEN', 'TOGGLE_HIDE_ANSWERED_QUESTIONS']);
